module.exports = __webpack_public_path__ + "static/img/a4289525.png";